/**
 * Yields to the main thread to avoid long tasks and improve TBT/INP.
 * Uses scheduler.yield() when available (prioritized continuation), else setTimeout(0).
 * @see https://web.dev/articles/optimize-long-tasks
 * @see https://developer.chrome.com/docs/lighthouse/performance/lighthouse-total-blocking-time
 */
const scheduler =
  typeof globalThis !== 'undefined'
    ? (globalThis as unknown as { scheduler?: { yield: () => Promise<void> } })
        .scheduler
    : undefined;

export function yieldToMain(): Promise<void> {
  if (scheduler?.yield) {
    return scheduler.yield();
  }
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}
